const mockAPI = () => process.env.REACT_APP_MOCK_API;
const isDev = () => window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('127.0.0.1') !== -1;
const dontWaitForChats = () => isDev() && process.env.REACT_APP_NO_DELAY;
const enableSentry = () => !isDev();
const enableAnalytics = () => !isDev();
const enableDataDog = () => !isDev();

export default { mockAPI, isDev, enableSentry, enableAnalytics, enableDataDog, dontWaitForChats };
